import { AuthService } from "@js/services/AuthService";
import { SharedCriteriaService } from "@js/services/Deal/SharedCriteriaService";
import { OrganisationService } from "@js/services/OrganisationService";
import { RoleService } from "@js/services/RoleService";
import { SelectListService } from "@js/services/SelectListService";
import { CriteriaController } from "./CriteriaController";
import { EnterpriseService } from "@js/services/EnterpriseService";
import {
  ApplicationUser,
  AreaUnitEnum,
  BrickflowEventLogClient,
  CaseStatusEnum,
  Client,
  DealClient,
  DealSourceTypeEnum,
  LinkSourceTypeEnum,
  DevelopmentFinanceDeal,
  DevelopmentFinanceDealClient,
  LinkTypeEnum,
  LocationEnum,
  Organisation,
  OrganisationClient,
  OrganisationLinkClient,
  OriginatorRoleTypeEnum,
  OwnOrPurchaseEnum,
  ProductFamilyEnum,
  ProductTypeEnum,
  PropertyTypeEnum,
  SaveDevFinanceSearchRequest,
  SaveSearchReturnUniqueRefResponse,
  ShareDealDTO,
  UserClient,
  UserRoleEnum,
  YesNoMaybe,
  ApplicationUserCrudClient,
} from "@src/apis/ModularClient";
import DealHelper from "@js/helpers/DealHelper";
import { DevFinanceDealService } from "@js/services/Deal/DevFinanceDealService";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class DevFinanceCriteriaController extends CriteriaController<DevelopmentFinanceDeal> {
  dealDto: DevelopmentFinanceDeal;
  tempDealDto: DevelopmentFinanceDeal;
  snapshotDealDto: DevelopmentFinanceDeal;
  productType: ProductTypeEnum;

  maxPurchaseDate: string;
  minPurchaseDate: Date = new Date("Jan 01 1900");
  isLoggedInUser: boolean = false;
  dataLoading: boolean = false;
  isSearchStarted: boolean = false;
  hasError: boolean = false;
  isSubmitted: boolean = false;
  error: string;

  multiPartForm1: ng.IFormController;

  //Share a search modal
  showShareSearchtoClientModal: boolean = false;
  existingborrower: boolean;

  //Message to show when Enterprise url does not have valid lead gen license status or whitelabel add on is not paid or whitelabel setting is not on.
  noPermissionErrorMsg: string = "";

  //Enterprise user clientId
  clientId: number = null;
  enterpriseUser: ApplicationUser = null;

  currentUseofBuildingOptions = [];
  locationOptions = [];
  loanCompletionTypeOptions = [];

  hasPurchaseCostChanged: boolean = false;

  guidanceCheckbox: boolean = true;

  isDeal: boolean = true;

  isBorrower: boolean = false;
  isAdmin: boolean = false;
  isBroker: boolean = false;
  isLender: boolean = false;
  organisation: Organisation;
  moveContactBrokerBtnInMiddle: boolean = false;
  initialRegistrationClient: Client;
  orgCode: string = "";
  buildCostPerSqFt: number;
  buildCostPerSqM: number;
  buildCostIntermediary: number;
  areaConversionFactor: number = 10.7639;
  contingencyValue: number;
  totalBuildCosts: number;
  defaultProfessionalCosts: number = 0.1;
  showAutofill: boolean = false;

  isCaseDashboard: boolean = false;

  isMobileView: boolean = false;
  showHelpModal: boolean = false;
  loanInfoText: string;
  progressAmount: string = "33%";
  progressSection: number = 1;
  totalSections: number = 3;
  enterpriseLinkLogo: string;

  isWidget: boolean = false;
  //This propert is used to show only postcode ot location field on critera for mobile view
  isCriteria: boolean = true;

  //orgLinkId: number = null;
  orgLinkSourceType: LinkSourceTypeEnum;

  static $inject = [
    "$scope",
    "$rootScope",
    "$routeParams",
    "$cookies",
    "$location",
    "$q",
    "UserClient",
    "RoleService",
    "OrganisationService",
    "OrganisationClient",
    "SelectListService",
    "DevFinanceDealService",
    "DevelopmentFinanceDealClient",
    "SharedCriteriaService",
    "BrickflowEventLogClient",
    "AuthService",
    "DealClient",
    "EnterpriseService",
    "OrganisationLinkClient",
    "ODataHelper",
    "ApplicationUserCrudClient",
  ];

  constructor(
    private $scope: ng.IScope,
    private $rootScope: ng.IRootScopeService,
    $routeParams: ng.route.IRouteParamsService,
    private $cookies: ng.cookies.ICookiesService,
    private $location: ng.ILocationService,
    protected $q: ng.IQService,
    userClient: UserClient,
    private roleService: RoleService,
    private organisationService: OrganisationService,
    private organisationClient: OrganisationClient,
    private selectListService: SelectListService,
    private devFinanceDealService: DevFinanceDealService,
    private developmentFinanceDealClient: DevelopmentFinanceDealClient,
    sharedCriteriaService: SharedCriteriaService,
    eventLogClient: BrickflowEventLogClient,
    private $auth: AuthService,
    dealService: DealClient,
    private enterpriseService: EnterpriseService,
    organisationLinkClient: OrganisationLinkClient,
    odataHelper: ODataHelper,
    applicationUserCrudClient: ApplicationUserCrudClient,
  ) {
    super(
      dealService,
      $routeParams,
      odataHelper,
      organisationLinkClient,
      sharedCriteriaService,
      applicationUserCrudClient,
      userClient,
      eventLogClient,
    );
    this.init();
  }

  async init() {
    try {
      if (this.$routeParams.linkId) {
        this.orgLinkId = Number(this.$routeParams.linkId);
      }

      if (this.$routeParams.context == "widget") {
        if (window.self != window.top) {
          this.isWidget = true;
        } else {
          this.noPermissionErrorMsg =
            "This URL is designed to be embedded into a site, as a widget. If you would like the user to access this search directly, please use an Enterpise link.";
        }
      } else {
        if (window.innerWidth <= 480) this.isMobileView = true;
      }

      this.maxPurchaseDate = new Date().toISOString().split("T")[0];

      if (this.$routeParams.uniqueId) {
        await this.getProductFamiliesByUniqueId();
      }

      //Initial data setup for a dev finance deal
      if (this.dealDto == null) {
        this.dealDto = {} as DevelopmentFinanceDeal;
        this.loanInfoText = "For all new-build, conversion or larger refurbishment projects";
        this.dealDto.isFamilyInResidence = YesNoMaybe.No;
        this.dealDto = this.devFinanceDealService.initialDataSetUpForDeal(this.dealDto);
        this.dealDto.grossInternalAreaKnown = true;
        this.dealDto.areaUnit = AreaUnitEnum.SquareFeet;
        this.dealDto.includesContingency = false;
        if (this.orgLinkId !== null && this.orgLinkId !== 0) {
          this.dealDto.organisationLinkId = this.orgLinkId;
        }
      }

      //Enteprise journey code
      if (!this.$cookies.get("access_token") && this.isValidEnterprisePath()) {
        if (window.self == window.top) {
          this.orgCode = this.$cookies.get("org_code") ?? null;
        } else {
          this.orgCode = location.pathname.replace("/", "");
        }

        await this.getEnterpriseOrganisationByOrgCode();

        if (this.orgLinkId === null || this.orgLinkId === undefined || this.orgLinkId === 0) {
          await this.getEnterpriseLinkId();
        }

        if (this.orgLinkId !== null || this.orgLinkId !== undefined || this.orgLinkId === 0) {
          this.organisationLinkClient
            .getLinkSourceType(this.orgLinkId, this.$location.absUrl())
            .then((linkSourceType: LinkSourceTypeEnum) => {
              if (linkSourceType !== null && linkSourceType !== undefined) {
                this.orgLinkSourceType = linkSourceType;
              } else {
                this.noPermissionErrorMsg = "We are unable to compare loans right now.  Please contact your broker.";
                return;
              }
            });
        }

        this.isBorrower = true;
        this.dealDto.originatorRoleType = OriginatorRoleTypeEnum.Borrower;

        if (this.$location.path().startsWith("/e/devfinancecriteria")) {
          const imgs = document.getElementsByTagName("img");
          this.enterpriseLinkLogo = imgs[0].src;
          //  this.sharedCriteriaService.storeEnterpriseLinkType(LinkTypeEnum.Development.toString());
          this.sharedCriteriaService.setPreviousUrl(this.$location.absUrl());
        }

        if (this.isWidget) {
          //document.getElementById("footer").style.display = "none";
          this.organisationService.sendDataToParent("height", "745px");
        }

        if (!this.$routeParams.DealUniqueRef || this.$routeParams.DealUniqueRef == "0") {
          if (window.self == window.top) {
            this.orgCode = this.$cookies.get("org_code") ?? null;
            sessionStorage.setItem("userRole", UserRoleEnum.Client.toString());
          } else {
            this.orgCode = location.pathname.replace("/", "");
            this.organisationService.sendDataToParent("userRole", UserRoleEnum.Client.toString());
          }

          await this.logEventWithoutDealData();
          this.logEvent("DEVFINANCECRITERIA-PAGE1");
          this.getOriginatorInfoForAnonymousUsers();
        }
      }

      if (window.self == window.top && this.$cookies.get("access_token")) {
        this.isLoggedInUser = true;

        this.userClient.getCurrentUserAutofill().then((response) => {
          this.showAutofill = response;
        });

        this.roleService
          .GetUserRoles()
          .then((result) => {
            if (result.filter((x) => x.toLowerCase() == "admin").length > 0) {
              this.isAdmin = true;
            }
            if (result.filter((x) => x.toLowerCase() == "broker").length > 0) {
              this.isBroker = true;
              if (!this.isAdmin)
                if (this.isBroker) {
                  // this.dealDto.originatorRoleType = OriginatorRoleTypeEnum.Broker;
                  //This block is to navigate a broker to userdashboard when they do not have a license.
                  if (sessionStorage.getItem("isValidLicense") == "false") {
                    this.gotoDashboard();
                  }
                }
            }
            if (result.filter((x) => x.toLowerCase() == "lender").length > 0 && !this.isAdmin) {
              this.isLender = true;
            }

            if (result.filter((x) => x.toLowerCase() == "client").length > 0 && !this.isAdmin) {
              this.isBorrower = true;
            }
          })
          .finally(() => {
            if (this.$auth.getHasValidStatustoShowShareSearchModal()) {
              if (sessionStorage.getItem("skip")) {
                //This will hide's a share search to client modal
                this.showShareSearchtoClientModal = false;
              } else {
                //getting a previously entered DealName and Client data
                if (DealHelper.getShowSearchNameAndUserSelectionModal()) {
                  this.showShareSearchtoClientModal = true;
                  this.getUsersBelongToBrokerOrAdmin();
                } else {
                  this.shareDealDto.clientDto = DealHelper.getClient();
                  this.shareDealDto.dealName = DealHelper.getDealName();
                }
              }
              this.getOriginatorInfoForUser();
            }
          });

        //This block is to navigate a broker to userdashboard when they do not have a license.
        if (sessionStorage.getItem("isValidLicense") == "false") {
          this.gotoDashboard();
        }
      } else {
        if (!this.$routeParams.DealUniqueRef || this.$routeParams.DealUniqueRef == "0") {
          if (window.self == window.top) {
            this.clientId = Number(sessionStorage.getItem("clientId"));
          } else {
            Promise.all([
              this.organisationService.getData("clientId").then((clientId) => {
                if (clientId) {
                  this.clientId = Number(clientId);
                }
              }),
            ]);
          }
        }
      }

      if (this.$routeParams.DealUniqueRef && this.$routeParams.DealUniqueRef != "0") {
        this.dataLoading = true;
        this.dealService
          .fetchByUniqueRef(this.$routeParams.DealUniqueRef)
          .then((response: DevelopmentFinanceDeal) => {
            this.dealDto = { ...response };
            this.snapshotDealDto = { ...response };
          })
          .finally(() => {
            this.dataLoading = false;
            this.updateCalculatedFields();
          });
      } else if (this.$routeParams.SearchId > 0) {
        this.dataLoading = true;
        this.developmentFinanceDealClient
          .fetch(this.$routeParams.SearchId)
          .then((response) => {
            this.dealDto = { ...response };
            this.snapshotDealDto = { ...response };
          })
          .finally(() => {
            this.dataLoading = false;
            this.updateCalculatedFields();
          });
      } else {
        this.dealDto.maxLoanRequired = true;
        this.dealDto.showLenderInfoBrokerOverride = true;
      }

      if (window.self == window.top) {
        this.updateGuidanceState();

        this.$rootScope.$on("guidanceStateChanged", (event: ng.IAngularEvent) => {
          this.updateGuidanceState();
        });
      }

      this.currentUseofBuildingOptions = this.selectListService.GetPropertyTypes(ProductTypeEnum.Development);
      this.locationOptions = this.selectListService.GetLocations();
      this.loanCompletionTypeOptions = this.selectListService.GetLoanCompletionOptions();
    } catch (e) {
      console.error("Error: ", e);
    }
  }

  async getEnterpriseOrganisationByOrgCode() {
    await this.organisationClient
      .getOrgByUrlIfOrgHasEnterpriseSearchPermission(
        this.orgCode,
        ProductFamilyEnum.Development,
        this.orgLinkId !== null ? this.orgLinkId.toString() : null,
      )
      .then((response) => {
        if (response) {
          this.organisation = response;
          this.orgCode = response.organisationCode;

          if (this.orgLinkId) {
            if (this.$location.path().startsWith("/e/devfinancecriteria")) {
              this.organisationLinkClient
                .getOrganisationLinkLogoByLinkIdAndLogPageLoadEvent(this.orgLinkId, "", 0, ProductTypeEnum.None, "", 0)
                .then((logoUrl) => {
                  const imgs = document.getElementsByTagName("img");
                  if (logoUrl != null && logoUrl.length > 0) this.enterpriseLinkLogo = imgs[0].src = logoUrl;
                });
            }
          }
        } else {
          this.logEvent("DEVFINANCECRITERIA-NO-PERMISSION-TO-SEARCH");
          this.noPermissionErrorMsg = "We are unable to compare loans right now.  Please contact your broker.";
        }
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  async getEnterpriseLinkId() {
    const linkType = this.$location.path().startsWith("/allloans") ? LinkTypeEnum.AllLoans : LinkTypeEnum.Commercial;

    try {
      // This is an enterprise link without an org link ID, so look up the ID
      await this.organisationLinkClient
        .getEnterpriseLinkId(this.organisation.id, linkType, this.$location.absUrl())
        .then((linkId) => {
          if (linkId !== null || linkId !== undefined || linkId !== 0) {
            this.orgLinkId = linkId;
          } else {
            this.noPermissionErrorMsg = "We are unable to compare loans right now.  Please contact your broker.";
            return;
          }
        });
    } catch (err) {
      this.noPermissionErrorMsg = "We are unable to compare loans right now.  Please contact your broker.";
      return;
    }
  }

  updateGuidanceState() {
    this.guidanceCheckbox = this.$cookies.get("guidance") === "on" || this.$cookies.get("guidance") === undefined;
  }

  //Clears the previously selected existing client data on share search modal
  clearInputFields() {
    this.shareDealDto = this.sharedCriteriaService.clearExistingUserOnShareDealDto(this.shareDealDto);
    this.showClientDetails = false;
  }

  getUsersBelongToBrokerOrAdmin() {
    this.userClient
      .getUserSummariesForBrokerOrAdmin()
      .then((response) => {
        this.existingUsers = response;
      })
      .finally(() => {});
  }

  gotoDashboard() {
    this.$auth.clearSelectedNavMenuAndFilterStorageData();
    this.$location.path("/userdashboard");
  }

  //new search share modal close btn function
  OnClickOfSkip() {
    this.showShareSearchtoClientModal = false;
    this.shareDealDto.clientDto = null;
    if (this.$location.path().startsWith("/allloans") && (this.isAdmin || this.isBroker)) {
      DealHelper.setShowSearchNameAndUserSelectionModal(false);
    }
  }

  //new search share modal next btn function
  onClickOfNext() {
    this.showShareSearchtoClientModal = false;
    if (this.$location.path().startsWith("/allloans") && (this.isAdmin || this.isBroker)) {
      DealHelper.setShowSearchNameAndUserSelectionModal(false);
      DealHelper.setClient(this.shareDealDto.clientDto);
      DealHelper.setDealName(this.shareDealDto.dealName);
    }
  }
  // End of Share a modal functions

  goToLoanSelectionOptions() {
    this.$auth.setHasValidStatustoShowShareSearchModal(true);
    this.$location.path("/allloans");
  }

  calculatePurchaseOrLandCost() {
    if (this.dealDto.purchasePrice && !this.hasPurchaseCostChanged) {
      this.dealDto.purchaseCosts = (this.dealDto.purchasePrice * 5) / 100;
    }
  }

  onPurchaseCostChange() {
    const purchaseCost = (this.dealDto.purchasePrice * 5) / 100;
    if (this.dealDto.purchaseCosts != purchaseCost) {
      this.hasPurchaseCostChanged = true;
    }
    this.calculateTotalProjectCosts();
  }

  datasetupOnOwnOrPurchaseChange() {
    this.dealDto = this.devFinanceDealService.datasetupOnOwnOrPurchaseChange(this.dealDto);
  }

  datasetupOnMaxLoanRequiredChange() {
    this.dealDto = DealHelper.dataSetupOnMaxLoanRequiredChange(this.dealDto);
  }

  onOwnOrPurchaseChange(OwnOrPurchase: boolean) {
    this.dealDto.ownOrPurchase = this.dealDto.hasOwnOrPurchase ? OwnOrPurchaseEnum.Own : OwnOrPurchaseEnum.Purchasing;
    this.datasetupOnOwnOrPurchaseChange();
  }

  onIsFamilyInResidenceChange() {
    this.dealDto.isFamilyInResidence = this.dealDto.hasIsFamilyInResidence ? YesNoMaybe.Yes : YesNoMaybe.No;
    this.clearSearchdata();
  }

  initialDataSetupForIsFamilyInResidence() {
    if (this.dealDto.hasIsFamilyInResidence) {
      this.dealDto.isFamilyInResidence = YesNoMaybe.Yes;
      this.dealDto.hasIsFamilyInResidence = true;
    } else {
      this.dealDto.isFamilyInResidence = YesNoMaybe.No;
      this.dealDto.hasIsFamilyInResidence = false;
    }
  }

  clearSearchdata() {
    this.dealDto = this.devFinanceDealService.clearSearchdata(this.dealDto);
  }

  async logEvent(identifier: string) {
    if (window.self == window.top) {
      if (sessionStorage.getItem("clientId")) {
        this.eventLogClient.logPageLoad(
          identifier,
          this.orgCode,
          "",
          "Client",
          this.dealDto.organisationLinkId,
          ProductTypeEnum.Development,
          "",
          this.dealDto.id,
          Number(sessionStorage.getItem("clientId")),
        );
      } else {
        this.eventLogClient.logPageLoad(
          identifier,
          this.orgCode,
          "",
          "Client",
          this.dealDto.organisationLinkId,
          ProductTypeEnum.Development,
          "",
          this.dealDto.id,
        );
      }
    } else {
      var clientId: number = null;
      clientId = Number(await this.organisationService.getData("clientId"));

      if (clientId) {
        this.eventLogClient.logPageLoad(
          identifier,
          this.orgCode,
          "",
          "Client",
          this.dealDto.organisationLinkId,
          ProductTypeEnum.Development,
          "",
          this.dealDto.id,
          clientId,
        );
      } else {
        this.eventLogClient.logPageLoad(
          identifier,
          this.orgCode,
          "",
          "Client",
          this.dealDto.organisationLinkId,
          ProductTypeEnum.Development,
          "",
          this.dealDto.id,
        );
      }
    }
  }

  goToSearchResults() {
    this.error = null;
    this.isSubmitted = true;
    this.isSearchStarted = true;
    this.hasError = false;
    // If enterprise
    if (!this.isLoggedInUser && this.isBorrower && this.isValidEnterprisePath()) {
      this.enterpriseService.setProductFamily(this.dealDto.productFamily);

      this.saveCriteriaReturnUniqueRef().then((response) => {
        if (!this.hasError) {
          this.sharedCriteriaService.setIsDataLoading(false);
          var uniqueRef = response as SaveSearchReturnUniqueRefResponse;
          if (window.self == window.top) sessionStorage.removeItem("productType");
          if (response.hasDealClient) {
            //The purpose of the route check is to ensure navigation to the correct route when the user lands on the criteria page by clicking 'Change Search' in the side panel.
            if (sessionStorage.getItem("previousRoute") == "referredsearchdeal") {
              this.$location.path(`/referredsearchdeal/${response.dealClientUniqueRef}/false`);
              sessionStorage.removeItem("previousRoute");
            } else {
              this.$location.path(`/e/devfinanceresults/${response.dealUniqueRef}`);
            }
          } else {
            var leadCaptureUrl = `/e/enterpriseleadcapture/${response.dealUniqueRef}`;
            leadCaptureUrl = this.isWidget ? `${leadCaptureUrl}/widget` : leadCaptureUrl;

            this.$location.path(leadCaptureUrl);
          }
        }
      });
    } else {
      this.saveCriteriaReturnId().then((response) => {
        if (!this.hasError) {
          var dealId = response as number;
          if (window.self == window.top) sessionStorage.removeItem("productType");
          if (this.isAdmin || this.isBroker) DealHelper.setShowSearchNameAndUserSelectionModal(true);
          this.$location.path("/devfinanceresults/" + dealId);
        }
      });
    }
  }

  searchDisabled() {
    if (this.progressSection == 1) {
      this.progressAmount = "0%";
      if (this.dealDto.locations == null || this.dealDto.locations <= 0 || this.showPostcodeErrorMessage) {
        return true;
      }

      if (this.multiPartForm1.$invalid) {
        return true;
      }

      this.progressAmount = "33%";
    }

    if (this.progressSection == 2) {
      this.progressAmount = "33%";

      if (this.multiPartForm1.$invalid) {
        return true;
      }

      this.progressAmount = "66%";
    }

    if (this.progressSection == 3) {
      this.progressAmount = "66%";

      if (this.dealDto.loanTermReq <= this.dealDto.buildTerm) {
        return true;
      }

      if (this.multiPartForm1.$invalid) {
        return true;
      }
      this.progressAmount = "100%";
    }

    return false;
  }

  saveCriteriaReturnId(): ng.IPromise<number> {
    let defer = this.$q.defer<number>();

    this.dataSetUpForSave();

    var clientDto = null;
    /*  if (
        !this.isLoggedInUser &&
        this.enterpriseUser &&
        this.$location.path().startsWith("/e/devfinancecriteria")
      ) {
        clientDto =
          this.sharedCriteriaService.setClientDtoDataForEnterpriseSearch(
            this.enterpriseUser,
            this.organisation.Id,
            clientDto,
          );
      }*/

    var request: SaveDevFinanceSearchRequest = {
      deal: this.dealDto,
      shareDealDto: this.shareDealDto,
      orgCode: this.isLoggedInUser ? "" : this.orgCode,
      clientId:
        !this.isLoggedInUser &&
        this.clientId &&
        !this.enterpriseUser &&
        this.$location.path().startsWith("/e/devfinancecriteria")
          ? Number(this.clientId)
          : 0,
      enterpriseClientDto: clientDto,
    };

    this.developmentFinanceDealClient
      .saveDevFinanceSearchReturnsId(request)
      .then((response) => {
        this.dealDto.id = response;

        defer.resolve(response as number);
        return response;
      })
      .catch((response) => {
        defer.reject(response);
        if (response.status === 500) {
          this.error = response.data.message;
        } else {
          this.error = "Something went wrong while searching for loans. Please try again.";
        }
        this.hasError = true;
        this.isSearchStarted = false;
      });

    return defer.promise;
  }

  saveCriteriaReturnUniqueRef(): ng.IPromise<SaveSearchReturnUniqueRefResponse> {
    let defer = this.$q.defer<SaveSearchReturnUniqueRefResponse>();

    this.sharedCriteriaService.setIsDataLoading(true);
    this.dataSetUpForSave();

    var clientDto = null;
    /*   if (!this.isLoggedInUser && this.enterpriseUser && this.$location.path().startsWith("/e/devfinancecriteria")) {
                clientDto = this.sharedCriteriaService.setClientDtoDataForEnterpriseSearch(this.enterpriseUser, this.brokerageOrg.Id, clientDto);
            }*/

    const request: SaveDevFinanceSearchRequest = {
      deal: this.dealDto,
      shareDealDto: this.shareDealDto,
      orgCode: this.isLoggedInUser ? "" : this.orgCode,
      clientId:
        !this.isWidget && !this.isLoggedInUser && this.clientId && !this.enterpriseUser && this.isValidEnterprisePath()
          ? Number(this.clientId)
          : 0,
      enterpriseClientDto: clientDto,
      sourceUrl: this.isLoggedInUser ? "" : this.sharedCriteriaService.getPreviousUrl(),
    };

    this.developmentFinanceDealClient
      .saveDevFinanceSearchReturnsUniqueRef(request)
      .then((response) => {
        this.dealDto.uniqueRef = response.dealUniqueRef;

        defer.resolve(response as SaveSearchReturnUniqueRefResponse);
        return response;
      })
      .catch((response) => {
        defer.reject(response);
        this.sharedCriteriaService.setIsDataLoading(false);
        if (response.status === 500) {
          this.error = response.data.message;
        } else {
          this.error = "Something went wrong while searching for loans. Please try again.";
        }
        this.hasError = true;
        this.isSearchStarted = false;
      });

    return defer.promise;
  }

  dataSetUpForSave() {
    this.sharedCriteriaService.setNewSearch(this.dealDto, this.snapshotDealDto);

    if (this.dealDto.id == null) {
      this.dealDto.status = CaseStatusEnum.Search;
    }

    if (this.dealDto.name == null || this.dealDto.name == "" || this.dealDto.name == undefined) {
      //Lender referred search
      if (sessionStorage.getItem("lenderReferralReference")) {
        this.dealDto.name = sessionStorage.getItem("lenderReferralReference");
      } else {
        this.dealDto.name = this.sharedCriteriaService.defaultSearchName(this.dealDto.productType);
      }
    }

    if (!this.isLoggedInUser && this.$location.path().startsWith("/e/devfinancecriteria") && this.isBorrower) {
      this.dealDto.howManyFlats = this.dealDto.howManyFlats ? this.dealDto.howManyFlats : 0;
      this.dealDto.howManyHouses = this.dealDto.howManyHouses ? this.dealDto.howManyHouses : 0;
    }

    if (!this.shareDealDto) {
      this.shareDealDto = {
        dealName: this.sharedCriteriaService.defaultSearchName(this.dealDto.productType),
      } as ShareDealDTO;
    } else {
      if (this.shareDealDto && this.shareDealDto.clientDto) {
        this.shareDealDto.clientDto.postalAddress = this.shareDealDto.clientDto.postalAddress ?? {
          addressLine1: "",
          addressLine2: "",
          addressLine3: "",
          addressLine4: "",
          postCode: "",
        };
        this.shareDealDto.clientDto.id = this.shareDealDto.clientDto.id ?? 0;
      }
    }
  }

  dummysearch() {
    this.dealDto.hasPostcode = this.sharedCriteriaService.getRandomIntInclusive(0, 1) == 1 ? true : false;

    if (this.dealDto.hasPostcode) {
      this.dealDto.postcodeSearchString = this.sharedCriteriaService.getRandomPostcode();
      this.getRegionByPostcode();
    } else {
      this.dealDto.locations = LocationEnum.London;
    }

    this.dealDto.ownOrPurchase =
      this.sharedCriteriaService.getRandomIntInclusive(0, 1) == 0
        ? OwnOrPurchaseEnum.Own
        : OwnOrPurchaseEnum.Purchasing;

    this.dealDto.purchasePrice = this.sharedCriteriaService.getRandomIntInclusive(5000000, 10000000);

    if (this.dealDto.ownOrPurchase == OwnOrPurchaseEnum.Own) {
      this.dealDto.hasOwnOrPurchase = true;

      let date = new Date();
      date.setDate(date.getDate() - this.sharedCriteriaService.getRandomIntInclusive(1, 1000));

      this.dealDto.originalPurchaseDate = date;
      this.dealDto.landTotalOtherCosts = this.sharedCriteriaService.getRandomIntInclusive(10000, 100000);
      this.dealDto.currentvalue =
        this.dealDto.purchasePrice + this.sharedCriteriaService.getRandomIntInclusive(-10000, 5000000);
    } else {
      this.dealDto.hasOwnOrPurchase = false;
      this.dealDto.purchaseCosts = this.sharedCriteriaService.getRandomIntInclusive(100000, 1000000);
    }

    this.dealDto.endPropertyType =
      this.sharedCriteriaService.getRandomIntInclusive(0, 1) == 0
        ? PropertyTypeEnum.Residential
        : PropertyTypeEnum.MixedUse;

    if (this.dealDto.endPropertyType == PropertyTypeEnum.MixedUse) {
      this.dealDto.commercialGDV = this.sharedCriteriaService.getRandomIntInclusive(100000, 10000000);
    }

    this.dealDto.grossInternalAreaKnown = this.sharedCriteriaService.getRandomIntInclusive(0, 1) == 0;

    if (this.dealDto.grossInternalAreaKnown) {
      this.dealDto.areaUnit =
        this.sharedCriteriaService.getRandomIntInclusive(0, 1) == 0
          ? AreaUnitEnum.SquareFeet
          : AreaUnitEnum.SquareMeters;
      var areaMultiplier = this.dealDto.areaUnit == AreaUnitEnum.SquareMeters ? 1 : this.areaConversionFactor;
      this.dealDto.areaAcquisition = this.sharedCriteriaService.getRandomIntInclusive(
        100 * areaMultiplier,
        10000 * areaMultiplier,
      );
      this.dealDto.buildCostPerArea = this.sharedCriteriaService.getRandomIntInclusive(
        1000 / areaMultiplier,
        10000 / areaMultiplier,
      );

      if (this.dealDto.areaUnit == AreaUnitEnum.SquareFeet) {
        this.buildCostPerSqFt = this.dealDto.buildCostPerArea;
      } else {
        this.buildCostPerSqM = this.dealDto.buildCostPerArea;
      }

      this.updateBuildArea();
    } else {
      this.buildCostIntermediary = this.sharedCriteriaService.getRandomIntInclusive(100000, 100000000);
    }

    this.dealDto.includesContingency = this.sharedCriteriaService.getRandomIntInclusive(0, 1) == 0;
    this.dealDto.contingency = this.sharedCriteriaService.getRandomIntInclusive(1, 30) / 100;
    this.updateContingency();

    this.dealDto.loanTermReq = this.sharedCriteriaService.getRandomIntInclusive(24, 100);
    this.dealDto.gdv = this.dealDto.purchasePrice + this.sharedCriteriaService.getRandomIntInclusive(-10000, 100000000);
    this.dealDto.maxLoanRequired = this.sharedCriteriaService.getRandomIntInclusive(0, 1) == 0;

    if (this.dealDto.maxLoanRequired == false) {
      this.dealDto.netLoanRequired = this.sharedCriteriaService.getRandomIntInclusive(10000, 5000000);
    }
  }

  hasValidNetLoanRequiredValue() {
    if (
      !this.dealDto.maxLoanRequired &&
      (this.dealDto.netLoanRequired == null || isNaN(this.dealDto.netLoanRequired) || this.dealDto.netLoanRequired <= 0)
    ) {
      return true;
    } else {
      return false;
    }
  }

  /*getRegionByPostcode() {
    if (
      /[a-zA-Z]/.test(this.dealDto.postcodeSearchString) &&
      /[0-9]/.test(this.dealDto.postcodeSearchString)
    ) {
      if (this.dealDto.postcodeSearchString.replace(" ", "").length <= 7) {
        this.dataLoading = true;
        this.dealService
          .getRegionByPostcode(this.dealDto.postcodeSearchString)
          .then((response) => {
            if (response.Location != null) {
              this.dealDto.locations = response.Location;
              this.showPostcodeErrorMessage = false;
            } else {
              this.postcodeErrorMsg = response.PostCodeErrorMessage;
              this.showPostcodeErrorMessage = true;
              this.dealDto.locations = null;
            }
          })
          .finally(() => {
            this.dataLoading = false;
          });
      } else {
        this.postcodeErrorMsg =
          "Please enter a more specific postcode to identify the location";
        this.showPostcodeErrorMessage = true;
      }
    } else {
      this.postcodeErrorMsg =
        "At least one letter and one number must be entered e.g. SW1.";
      this.showPostcodeErrorMessage = true;
    }
  }*/

  updateBuildArea(initial: boolean = false) {
    if (this.dealDto.areaUnit == AreaUnitEnum.SquareFeet) {
      this.dealDto.buildCostPerArea = this.buildCostPerSqFt;
      this.buildCostPerSqM = this.convertSqFtToSqM(this.buildCostPerSqFt);
    } else {
      this.dealDto.buildCostPerArea = this.buildCostPerSqM;
      this.buildCostPerSqFt = this.convertSqMToSqFt(this.buildCostPerSqM);
    }

    if (!initial) {
      this.calculateBuildCostIntermediary();
    }
  }

  convertSqMToSqFt(costPerSqM: number): number {
    return costPerSqM / this.areaConversionFactor;
  }

  convertSqFtToSqM(costPerSqFt: number): number {
    return costPerSqFt * this.areaConversionFactor;
  }

  calculateBuildCostIntermediary() {
    if (this.dealDto.grossInternalAreaKnown && this.dealDto.buildCostPerArea > 0 && this.dealDto.areaAcquisition > 0) {
      this.buildCostIntermediary = this.dealDto.areaAcquisition * this.dealDto.buildCostPerArea;
    }
    this.calculateContingency();
  }

  calculateContingency() {
    if (this.dealDto.includesContingency) {
      this.contingencyValue =
        this.buildCostIntermediary - this.buildCostIntermediary / (1 + Number(this.dealDto.contingency));
    } else {
      this.contingencyValue = this.buildCostIntermediary * this.dealDto.contingency;
    }
    this.calculateTotalBuildCost();
  }

  calculateTotalBuildCost() {
    if (this.dealDto.includesContingency) {
      this.totalBuildCosts = this.buildCostIntermediary;
      this.dealDto.buildCosts = Number(this.buildCostIntermediary) - this.contingencyValue;
    } else {
      this.totalBuildCosts = Number(this.buildCostIntermediary) + this.contingencyValue;
      this.dealDto.buildCosts = Number(this.buildCostIntermediary);
    }

    this.calculateProfessionalCosts();
  }

  calculateProfessionalCosts() {
    if (this.multiPartForm1?.additionalOngoingCosts?.$dirty == false) {
      this.dealDto.additionalOngoingCosts = this.totalBuildCosts * this.defaultProfessionalCosts;
    }

    this.calculateTotalProjectCosts();
  }

  calculateTotalProjectCosts() {
    var totalCosts = 0;

    if (isNaN(Number(this.dealDto.additionalOngoingCosts)) == false) {
      totalCosts += Number(this.dealDto.additionalOngoingCosts);
    }

    if (isNaN(Number(this.totalBuildCosts)) == false) {
      totalCosts += Number(this.totalBuildCosts);
    }

    if (
      this.dealDto.ownOrPurchase == OwnOrPurchaseEnum.Own &&
      isNaN(Number(this.dealDto.landTotalOtherCosts)) == false
    ) {
      totalCosts += Number(this.dealDto.landTotalOtherCosts);
    }

    if (isNaN(Number(this.dealDto.purchasePrice)) == false) {
      totalCosts += Number(this.dealDto.purchasePrice);
    }

    if (
      this.dealDto.ownOrPurchase == OwnOrPurchaseEnum.Purchasing &&
      isNaN(Number(this.dealDto.purchaseCosts)) == false
    ) {
      totalCosts += Number(this.dealDto.purchaseCosts);
    }

    this.dealDto.totalProjectCosts = totalCosts;
  }

  updateGIA() {
    this.calculateBuildCostIntermediary();
  }

  updateContingency() {
    this.calculateContingency();
  }

  toggleKnowsGIA() {
    this.dealDto.grossInternalAreaKnown = !this.dealDto.grossInternalAreaKnown;
    if (this.dealDto.grossInternalAreaKnown == true) {
      this.dealDto.areaUnit = AreaUnitEnum.SquareFeet;
    } else {
      this.dealDto.areaAcquisition = null;
      this.dealDto.areaUnit = null;
      this.buildCostPerSqFt = null;
      this.buildCostPerSqM = null;
      this.dealDto.buildCostPerArea = null;
    }

    this.buildCostIntermediary = null;
    this.multiPartForm1.buildCostIntermediary.$setUntouched();
    this.updateContingency();
  }

  updateCalculatedFields() {
    this.reverseBuildCost();
    this.reverseBuildCostPerArea();
    this.updateBuildArea(true);
    this.updateContingency();
  }

  reverseBuildCostPerArea() {
    if (this.dealDto.areaUnit == AreaUnitEnum.SquareFeet) {
      this.buildCostPerSqFt = this.dealDto.buildCostPerArea;
    } else {
      this.buildCostPerSqM = this.dealDto.buildCostPerArea;
    }
  }

  reverseBuildCost() {
    if (this.dealDto.includesContingency == true) {
      this.buildCostIntermediary = Math.round(this.dealDto.buildCosts * (1 + this.dealDto.contingency) * 100) / 100;
    } else {
      this.buildCostIntermediary = this.dealDto.buildCosts;
    }
  }

  getRequiredRoles(isCaseDashboard: boolean) {
    if (isCaseDashboard) return `['Admin', 'Client', 'Broker', 'Introducer']`;
    return `['Admin', 'Client', 'Broker', 'Introducer', 'Lender']`;
  }

  /*onHasPostcodeChange() {
    if (!this.dealDto.hasPostcode) {
      this.showPostcodeErrorMessage = false;
      this.dealDto.postcodeSearchString = null;
      this.dealDto.locations = this.previouslySelectedLocation;
    } else {
      this.previouslySelectedLocation = this.dealDto.locations;
      this.dealDto.locations = null;
    }
  }*/

  isFieldEmpty(fieldName, isEnum = false) {
    if (this.isSubmitted && this.dealDto) {
      const fieldValue = this.dealDto[fieldName];
      if (fieldName == "PlanningPermissionType") {
        if (fieldValue == null || fieldValue < 1) {
          return true;
        }
      }
      if (fieldValue == null || (isEnum && fieldValue === "0")) {
        return true;
      }
    }

    return false;
  }

  isFieldZero(fieldName) {
    if (this.isSubmitted && this.dealDto) {
      const fieldValue = this.dealDto[fieldName];
      if (fieldValue == null || fieldValue === "0" || fieldValue === 0) {
        return true;
      }
    }

    return false;
  }

  showBasedOnMainResidence() {
    return DealHelper.showBasedOnMainResidence(this.dealDto);
  }

  clickNextButton() {
    if (this.progressSection == 1) {
      if (!this.isLoggedInUser && this.isValidEnterprisePath()) {
        this.logEvent("DEVFINANCECRITERIA-PAGE2");
      }
      this.progressSection = 2;
    } else {
      if (!this.isLoggedInUser && this.isValidEnterprisePath()) {
        this.logEvent("DEVFINANCECRITERIA-PAGE3");
      }
      this.progressSection = 3;
    }
  }

  clickBackButton() {
    if (this.progressSection == 3) {
      if (!this.isLoggedInUser && this.isValidEnterprisePath()) {
        this.logEvent("DEVFINANCECRITERIA-PAGE2");
      }
      this.progressSection = 2;
    } else {
      if (!this.isLoggedInUser && this.isValidEnterprisePath()) {
        this.logEvent("DEVFINANCECRITERIA-PAGE1");
      }
      this.progressSection = 1;
    }
  }

  isCriteriaFormInValid() {
    if (
      this.isSearchStarted ||
      this.multiPartForm1.$invalid ||
      this.dealDto.locations == null ||
      this.dealDto.locations <= 0 ||
      this.hasValidNetLoanRequiredValue() ||
      this.showPostcodeErrorMessage ||
      this.dealDto.gdv == null ||
      this.dealDto.gdv == 0
    ) {
      if (this.isSearchStarted) {
        this.progressAmount = "100%";
      } else {
        this.progressAmount = "66%";
      }
      return true;
    } else {
      this.progressAmount = "100%";
      return false;
    }
  }

  async logEventWithoutDealData() {
    if (window.self == window.top) {
      if (sessionStorage.getItem("clientId")) {
        await this.eventLogClient.logPageLoad(
          "DEVFINANCECRITERIA",
          this.orgCode,
          "",
          "Client",
          this.orgLinkId ? this.orgLinkId : null,
          ProductTypeEnum.Development,
          "",
          0,
          Number(sessionStorage.getItem("clientId")),
        );
      } else {
        await this.eventLogClient.logPageLoad(
          "DEVFINANCECRITERIA",
          this.orgCode,
          "",
          "Client",
          this.orgLinkId ? this.orgLinkId : null,
          ProductTypeEnum.Development,
        );
      }
    } else {
      var clientId: number = null;
      clientId = parseInt(await this.organisationService.getData("clientId"), 10) || 0;

      if (clientId && clientId > 0) {
        await this.eventLogClient.logPageLoad(
          "DEVFINANCECRITERIA",
          this.orgCode,
          "",
          "Client",
          this.orgLinkId ? this.orgLinkId : null,
          ProductTypeEnum.Development,
          "",
          0,
          clientId,
        );
      } else {
        await this.eventLogClient.logPageLoad(
          "DEVFINANCECRITERIA",
          this.orgCode,
          "",
          "Client",
          this.orgLinkId ? this.orgLinkId : null,
          ProductTypeEnum.Development,
        );
      }
    }
  }

  getOriginatorInfoForUser() {
    if (this.isAdmin) {
      this.dealDto.originatorRoleType = OriginatorRoleTypeEnum.Admin;
      this.dealDto.sourceType = DealSourceTypeEnum.Application;
    } else if (this.isBroker && !this.isAdmin) {
      this.dealDto.originatorRoleType = OriginatorRoleTypeEnum.Broker;
    } else if (this.isBorrower && !this.isAdmin) {
      this.dealDto.originatorRoleType = OriginatorRoleTypeEnum.Borrower;
    } else if (this.isLender && !this.isAdmin) {
      this.dealDto.originatorRoleType = OriginatorRoleTypeEnum.Lender;
      this.dealDto.sourceType = DealSourceTypeEnum.Application;
    }

    if (window.self == window.top) {
      if (this.isLender) {
        this.userClient.getCurrentUserLender().then((response) => {
          this.dealDto.originatorLenderId = response;
        });
      }

      if (this.isBroker || this.isBorrower) {
        this.organisationService.getOrganisation().then((org) => {
          if (org != null) {
            if (org.id != 0) this.dealDto.originatorOrganisationId = org.id;
            this.dealDto.sourceType = org.isWhiteLabelled
              ? DealSourceTypeEnum.WhitelabelApplication
              : DealSourceTypeEnum.Application;
          }
        });
      }
    }
  }

  getOriginatorInfoForAnonymousUsers() {
    this.dealDto.originatorRoleType = OriginatorRoleTypeEnum.Borrower;

    if (window.self == window.top) {
      this.dealDto.sourceType = DealSourceTypeEnum.Enterprise;
    } else {
      this.dealDto.sourceType = this.isWidget
        ? DealSourceTypeEnum.WidgetEnterprise
        : DealSourceTypeEnum.IFrameEnterprise;
    }

    if (this.orgLinkId !== null && this.orgLinkId !== undefined) {
      const isEnterprise = window.self === window.top;
      const isManualUniqueLink = this.orgLinkSourceType === LinkSourceTypeEnum.Manual;
      const isEnterpriseUniqueLink = this.orgLinkSourceType === LinkSourceTypeEnum.Enterprise;

      if (isEnterprise) {
        this.dealDto.sourceType = isManualUniqueLink ? DealSourceTypeEnum.UniqueLink : DealSourceTypeEnum.Enterprise;
      } else if (this.isWidget) {
        this.dealDto.sourceType = isEnterpriseUniqueLink
          ? DealSourceTypeEnum.WidgetEnterprise
          : DealSourceTypeEnum.WidgetUniqueLink;
      } else {
        this.dealDto.sourceType = isManualUniqueLink
          ? DealSourceTypeEnum.IFrameUniqueLink
          : DealSourceTypeEnum.IFrameEnterprise;
      }
    }
  }

  getRequiredRolesOptions() {
    return DealHelper.getRequiredRolesOptions();
  }

  isValidEnterprisePath() {
    const path = this.$location.path();
    const validPaths = ["/e/devfinancecriteria", "/allloans", "/enterprise"];

    return validPaths.some((prefix) => path.startsWith(prefix));
  }

  setShowVATBridgingModal() {
    this.showVATBridgingModal = true;
    this.eventLogClient.logPageLoad(
      "VATBRIDGING-CRITERIA-URL-CLICKED",
      "",
      (this.$rootScope as any)?.currentUser?.userName,
      "",
      null,
      this.dealDto.productType,
    );
  }
}
